export function snapTimeStringToQuarterHour(timeStr) {
  if (!timeStr || typeof timeStr !== "string") return "";
  const [hStr, mStr] = timeStr.split(":");
  let hours = parseInt(hStr, 10);
  let minutes = parseInt(mStr, 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return timeStr;

  const rounded = Math.round(minutes / 15) * 15;
  if (rounded === 60) {
    minutes = 0;
    hours = (hours + 1) % 24;
  } else {
    minutes = rounded;
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function snapDateToQuarterHour(dateObj) {
  if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) {
    return null;
  }
  const minutes = dateObj.getMinutes();
  const rounded = Math.round(minutes / 15) * 15;
  const next = new Date(dateObj.getTime());
  if (rounded === 60) {
    next.setHours(next.getHours() + 1);
    next.setMinutes(0, 0, 0);
  } else {
    next.setMinutes(rounded, 0, 0);
  }
  return next;
}
